import { Pair } from "./Pair";

export class ChartElement {
   title: string;
   color: string;
   val: number;
   hasCallout: boolean;
   leftShift: number = 0;
   rightShift: number = 0;
   relatedSlidePos: number|null = null;
   infoText: string;
   funcLink: () => void|null;
}


